import React from 'react'
import { Typography } from '@mui/material'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction'
import ListItemText from '@mui/material/ListItemText'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'react-i18next'

type AddedDocumentsListPropTypes = {
  documents: DocumentReturnType[]
  documentsUploading: File[]
  deleteDocument: (id: string) => void
}

const AddedDocumentsList: React.FC<AddedDocumentsListPropTypes> = ({
  documents,
  documentsUploading,
  deleteDocument
}) => {
  const { t } = useTranslation()
  return (
    <>
      {(documentsUploading.length > 0 || documents.length > 0) && (
        <Typography variant="body2" color="textSecondary">
          {t('documents')}
        </Typography>
      )}

      {documents.length > 0 && (
        <List dense={true}>
          {documents.map((document) => (
            <ListItem key={document.id}>
              <ListItemText primary={document.originalName} />
              <ListItemSecondaryAction>
                <IconButton
                  edge="end"
                  aria-label="delete"
                  onClick={(): void => deleteDocument(document.id)}
                  size="large"
                >
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}

      {documentsUploading.length > 0 && (
        <List dense={true}>
          {documentsUploading.map((document) => (
            <ListItem key={document.name}>
              <ListItemText primary={document.name} />
              <ListItemSecondaryAction>
                <CircularProgress size={24} />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      )}
    </>
  )
}

export default AddedDocumentsList
